export default "__VITE_ASSET__YBakcx4B__";